function Camera({ style }) {
  const { width = 200, height = 200 } = style;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="100"
        cy="100"
        r="99"
        fill="white"
        stroke="#63637B"
        strokeWidth="2"
        strokeDasharray="12 12"
      />
      <path
        d="M89.017 66.667C88.4515 66.667 87.934 66.9851 87.6786 67.4898L83.1346 76.4709H65.2775C61.4302 76.4709 58.333 79.5317 58.333 83.3337V126.471C58.333 130.273 61.4302 133.334 65.2775 133.334H134.722C138.569 133.334 141.666 130.273 141.666 126.471V83.3337C141.666 79.5317 138.569 76.4709 134.722 76.4709H116.865L112.321 67.4898C112.065 66.9851 111.548 66.667 110.982 66.667H89.017ZM99.9997 87.2552C109.862 87.2552 117.857 95.1561 117.857 104.902C117.857 114.648 109.862 122.549 99.9997 122.549C90.1376 122.549 82.1425 114.648 82.1425 104.902C82.1425 95.1561 90.1376 87.2552 99.9997 87.2552Z"
        fill="#63637B"
      />
    </svg>
  );
}

export default Camera;
